export const subtitles = {
    "1": {
        "startTime": 0.0,
        "endTime": 3.7,
        "transcript": "...taumek aipangellrulliniunga.",
        "translation": "...he became my husband."
    },
    "2": {
        "startTime": 4.0,
        "endTime": 8.41,
        "transcript": "Tua-i-ll' tauma pianga",
        "translation": "Then that person said to me"
    },
    "3": {
        "startTime": 9.28,
        "endTime": 17.34,
        "transcript": "\"Kitak' tua-i itra. Aturaten ukut itrauciiqanka waniku.\"",
        "translation": "\"Now, go in. I will bring your clothes upriver later.\""
    },
    "4": {
        "startTime": 18.085,
        "endTime": 25.905,
        "transcript": "Kiani, uani Keggukarmiut kiaqliitni uitaluta Kelliqucirmiuni-gguq wani.",
        "translation": "Upriver, we lived downriver upriver from Keggukarmiut in a place called Kelliqucirmiut."
    },
    "5": {
        "startTime": 26.38,
        "endTime": 35.7,
        "transcript": "Aren tua-i-llu itrarlua unuakuarmi yuut makut tupalliniata",
        "translation": "Oh my, then I went in when these people woke up in the early morning"
    },
    "6": {
        "startTime": 35.709,
        "endTime": 42.995,
        "transcript": "Kaminiarturayuitellratni, ellakun saanilitullratni kenillerteggun.",
        "translation": "When they didn't use stoves, when they made kettles of hot water outside in fireplaces."
    },
    "7": {
        "startTime": 43.365,
        "endTime": 54.794,
        "transcript": "Aren tua-i itrarlua tua-i yuut makut tua-i tangva'gqatnga tua-i cukarikanirlua ulurluki piaqlua.",
        "translation": "Oh my, when I went in and these people watched me, I would go more quickly and look away from them."
    },
    "8": {
        "startTime": 54.961,
        "endTime": 63.819,
        "transcript": "Aren tua-i itrama tua-i kiiryuama-ll' u͡gayarlua, taukut-llu ciunerma qaill' pinrilatnga.",
        "translation": "Oh my, when I went it, I undressed because I was hot, and because those before me didn't do anything to me."
    },
    "9": {
        "startTime": 64.049,
        "endTime": 70.42,
        "transcript": "U͡gayarlua tua-i aanama-ll' imum qaill' pinrilan camek-llu qanrutevkenii.",
        "translation": "I undressed because my mother didn't do anything and didn't say anything to me."
    },
    "10": {
        "startTime": 71.041,
        "endTime": 72.999,
        "transcript": "U͡gayarlua.",
        "translation": "I undressed."
    },
    "11": {
        "startTime": 73.001,
        "endTime": 77.758,
        "transcript": "Qavarniama tua-i inarrlua tayim' qavallinilua.",
        "translation": "I lay down because I was sleepy and ended up falling asleep."
    },
    "12": {
        "startTime": 77.908,
        "endTime": 87.908,
        "transcript": "Cunaw' tua-i tuaten aipangucilqa nallumanaluku, kiituan uterrluta kingunemteńun tekitukut.",
        "translation": "It turned out that I wouldn't know that I had gotten married for a long time, until eventually we arrived back home."
    },
    "13": {
        "startTime": 88.645,
        "endTime": 101.188,
        "transcript": "Cunawa-gguq waniwa pitsaqutmek tauna angun ciullegyugciurluni tua-i takarnirlua.",
        "translation": "It turned out, they said, that that man purposely wanted us to go before him to make me respectfully withdrawn."
    },
    "14": {
        "startTime": 102.344,
        "endTime": 106.458,
        "transcript": "Tua-i tuaten tua-i nallunrillruaqa.",
        "translation": "That's how I found out."
    },
    "15": {
        "startTime": 106.653,
        "endTime": 113.867,
        "transcript": "Tua-i uingqerruciqa nalluku tua-i yuulua.",
        "translation": "I lived without knowing that I had a husband."
    },
    "16": {
        "startTime": 113.882,
        "endTime": 122.611,
        "transcript": "Atam tua-i uksuarumainanrani uqtaqutullratni ingkut ellangvillrenka Cevv'arnermiut",
        "translation": "You see, during the fall, when the people of Chefornak over there where I grew up used to use hookless lures when dipnetting."
    },
    "17": {
        "startTime": 122.619,
        "endTime": 124.519,
        "transcript": "Tuani-qaa yuurtellruuten?",
        "translation": "Were you born there?"
    },
    "18": {
        "startTime": 126.067,
        "endTime": 129.053,
        "transcript": "Cevv'arnermiuni yuurtellrunritua.",
        "translation": "I wasn't born in Chefornak."
    },
    "19": {
        "startTime": 129.062,
        "endTime": 136.619,
        "transcript": "Up'nerkami-gguq Isrimiuni wani up'nerkillerni May-aami yuurtellruunga.",
        "translation": "They said that I was born in the spring in Isrimiut, a spring camp, in May."
    },
    "20": {
        "startTime": 136.804,
        "endTime": 144.175,
        "transcript": "Atakuyartuan-llu-gguq kayangutellriartangqerrluni tauna yuurtelqa.",
        "translation": "And they said that near evening, there was someone who found eggs when I was born then."
    },
    "21": {
        "startTime": 144.197,
        "endTime": 149.34,
        "transcript": "Nateqsigta tauna Isrmiu? Isrimiut Cevv'arnermiut natiitni?",
        "translation": "How far is Isrimiu? Isrimiut, which direction from Chefornak?"
    },
    "22": {
        "startTime": 149.52,
        "endTime": 154.72,
        "transcript": "Ketiitni camani ingrik. Ingrik-qaa tangeqsaitagken? (Tanglaragka.)",
        "translation": "Toward the water down in the mountains. Haven't you seen the mountains? (I see them.)"
    },
    "23": {
        "startTime": 154.74,
        "endTime": 162.04,
        "transcript": "Ingriik ketiigni. Ingriik ingkuk ketiigni Qipnermiut akiqliigketa.",
        "translation": "Toward the water from the mountains. Toward the water from the mountains across from Kipnuk."
    },
    "24": {
        "startTime": 162.043,
        "endTime": 164.371,
        "transcript": "Nunaullruut-qaa taukut wall'u-qaa uksuillret?",
        "translation": "Was that a village or a winter camp?"
    },
    "25": {
        "startTime": 164.373,
        "endTime": 171.958,
        "transcript": "Nunarpauluteng nunauluteng. Enet amllerrluteng nevulget up'nerkissuutait.",
        "translation": "They were a big village. There were a lot of houses with sod for their spring camps."
    },
    "26": {
        "startTime": 171.981,
        "endTime": 179.196,
        "transcript": "Ukaqliit-wa cali Nuuteqerrmiut cali enetarluteng, qasgingqerraqluteng.",
        "translation": "And toward here, Nuuteqerrmiut also had houses, and they had a community house."
    },
    "27": {
        "startTime": 179.205,
        "endTime": 187.476,
        "transcript": "Yaaqliit-wa call' ingkut Cevv'arnermiunek nutaan yulget. Qikertaarmiut call' yugyapiarluteng.",
        "translation": "Over from them was the populated place of Chefornak. There were also a lot of people in Qikertaarmiut."
    },
    "28": {
        "startTime": 187.493,
        "endTime": 197.893,
        "transcript": "Canimelulluteng tua-i. Qimugtet-llu nepliralriit alaitaqluteng, yuut-llu tarritellriit alaitaqluteng.",
        "translation": "They were close together. And the baying dogs were visible, and people wandering were visible."
    },
    "29": {
        "startTime": 198.314,
        "endTime": 204.857,
        "transcript": "Aren canimelutqapiggluteng taukut up'nerkillrit.",
        "translation": "Oh my, their summer camps were very close together."
    },
    "30": {
        "startTime": 205.124,
        "endTime": 215.624,
        "transcript": "Wani tua-i imkut nauvillrenka wii ukaqliitnun Isrimiunun-gguq wavet up'nerkitullruut, Isrimiuni.",
        "translation": "They said that the place I grew up would set up spring camps on this where they called in Isrimiut, in Isrimiut."
    },
    "31": {
        "startTime": 215.944,
        "endTime": 220.944,
        "transcript": "Arenqiapaa-ll' up'nerkiluteng.",
        "translation": "Oh my goodness, they were at spring camp."
    },
    "32": {
        "startTime": 221.252,
        "endTime": 226.152,
        "transcript": "Makut-wa tang avatiitni ircenrrarugaat.",
        "translation": "You see, there were a lot of legendary little people around them."
    },
    "33": {
        "startTime": 226.166,
        "endTime": 229.037,
        "transcript": "Uurcartangnaurtuq-llu.",
        "translation": "And one with a signaling gaff would appear."
    },
    "34": {
        "startTime": 229.056,
        "endTime": 233.713,
        "transcript": "Nunanun-llu waniw' tekitarkaurrluni uurcaq taun' tamarluni.",
        "translation": "And when the one with the signaling gaff was going to reach the village, it would disappear."
    },
    "35": {
        "startTime": 233.721,
        "endTime": 243.078,
        "transcript": "Tamaqertelluku-llu maaken caniatnek ikamrat makut qavciunguluteng-llu tayim' ketmurrluteng.",
        "translation": "And after it disappeared, there would be some amount of sleds going to the water beside them."
    },
    "36": {
        "startTime": 243.331,
        "endTime": 252.216,
        "transcript": "Ketmurqaarluteng yuut taukut nunat ukut up'nerkilriit ciungatni piurluteng tamakut ircenrraat.",
        "translation": "After they went to the water, those legendary little people would keep ahead of the people from that spring camp settlement."
    },
    "37": {
        "startTime": 252.235,
        "endTime": 255.549,
        "transcript": "Ciungatni tua-i piurluteng.",
        "translation": "They kept ahead of them."
    },
    "38": {
        "startTime": 260.594,
        "endTime": 270.737,
        "transcript": "Ikamrat makut ketmurqaarluteng kelutmurrnaurtut. Ikamrait-wa kavirpak imaqaarluteng unguvalrianek.",
        "translation": "After those sleds went to the water, they would go inland. Their sleds were read, filled full with animals."
    },
    "39": {
        "startTime": 271.294,
        "endTime": 283.18,
        "transcript": "Tua-i-ll' atakuqerluku tayima tua-i ikamrat imkut maavet tua-i ingriik tungiignun tayim' ayagaqluteng.",
        "translation": "Then right when evening came, those sleds would go here toward the mountains."
    },
    "40": {
        "startTime": 285.671,
        "endTime": 295.057,
        "transcript": "Atakuqerluku nutaan uurcartangluni waken nunanek kingunelegmek up'nerkilrianek.",
        "translation": "In the evening, there would be one with a signaling gaff who was from this spring camp settlement."
    },
    "41": {
        "startTime": 295.611,
        "endTime": 304.182,
        "transcript": "Tua-i-llu qasgitangqellruuq elatemteggun gguun qasgigpagmek, qasgigpaarayagarmek.",
        "translation": "Then there was a community house outside of our house here, a huge community house."
    },
    "42": {
        "startTime": 304.477,
        "endTime": 314.391,
        "transcript": "Ap'au͡rlurput una Evngum-gguq una atii tailuni qasgim kepneranun pikavet aqumqerluni",
        "translation": "Our dear grandfather, the one they said was Evnguq's father, would come and sit up there on the above-ground entrance of the community house"
    },
    "43": {
        "startTime": 314.407,
        "endTime": 320.322,
        "transcript": "Un'a uurcaq tagelria ukavet tua-i aturpauqurluku.",
        "translation": "He sang to the one withe the signaling gaff who was coming inland toward here."
    },
    "44": {
        "startTime": 320.425,
        "endTime": 329.311,
        "transcript": "Wangkuta-w' tua-i naseknagni tan'gaurluut-llu unglumakevut, ungluluku niicugnikvut.",
        "translation": "And we girls and boys would embrace him like a nest, embraced and listened to him."
    },
    "45": {
        "startTime": 329.707,
        "endTime": 334.35,
        "transcript": "Aren kiituani tang yuarutii-llu elitarput.",
        "translation": "Oh my, we even eventually learned his song."
    },
    "46": {
        "startTime": 334.663,
        "endTime": 341.249,
        "transcript": "Waten tang atutullrulria tauna uurcaq tangvaurluku:",
        "translation": "You see, he would sing like this, watching that one with the signaling gaff:"
    },
    "47": {
        "startTime": 341.391,
        "endTime": 347.362,
        "transcript": "\"Uurca-raya-yarra-ii-ya",
        "translation": "\"One with the signaling gaff-raya-yarra-ii-ya"
    },
    "48": {
        "startTime": 347.379,
        "endTime": 353.707,
        "transcript": "\"Aa-ii-ya can'guaravluarrlugaat",
        "translation": "\"Aa-ii-ya [?the many blades of grass]"
    },
    "49": {
        "startTime": 353.719,
        "endTime": 361.434,
        "transcript": "\"Issur-issur-issur-issur maklassi-yaa-yarra-ii-ya",
        "translation": "\"Spotted seal-spotted seal-spotted seal-spotted seal, bearded seal-yaa-yarra-ii-ya"
    },
    "50": {
        "startTime": 361.451,
        "endTime": 367.208,
        "transcript": "\"Aa-ii-ya can'guaravluarrlugaat.\"",
        "translation": "\"Aa-ii-ya [?the many blades of grass.\""
    },
    "51": {
        "startTime": 367.225,
        "endTime": 372.496,
        "transcript": "Tua-i elicingqapiggluk' wangkuta niicugnistaini.",
        "translation": "We who listened to him completely learned it."
    },
    "52": {
        "startTime": 374.469,
        "endTime": 381.226,
        "transcript": "Uurcam-ll' imum tekicami urenkelluku ciuqerranun nang'arcami",
        "translation": "When the one with the signaling gaff arrived, when he stood in front of him with clear intent"
    },
    "53": {
        "startTime": 381.229,
        "endTime": 389.672,
        "transcript": "Negcikcuaraminek, negcikcuarani kapuarrluku wavet elliqerluku qanemciluni.",
        "translation": "He stuck his small gaff in the ground, put it here, and told a story."
    },
    "54": {
        "startTime": 389.989,
        "endTime": 395.889,
        "transcript": "Aqvalgirarkanek, aqvalgirarkat qanrulluki.",
        "translation": "He told the ones who would get [the animals they caught]."
    },
    "55": {
        "startTime": 396.355,
        "endTime": 407.826,
        "transcript": "Tua-i aren imkut ircenrraat ciungatni pillret amllertatait unuaquaqan ketmurrnaurtut.",
        "translation": "Oh my, the same number of legendary little people would go to the water in front of them every day."
    },
    "56": {
        "startTime": 408.03,
        "endTime": 414.673,
        "transcript": "Amllertacirkait cunaw' tua-i waniw' ciungatni maniurluki tamakut.",
        "translation": "It turned out that they would show beforehand how many there would be."
    },
    "57": {
        "startTime": 415.517,
        "endTime": 424.474,
        "transcript": "Aling tua-i amllertatait imkut ketmurtellret unuaquaqan aqvalgirluteng tayim' ayaganaurtut.",
        "translation": "Oh my, the same number that would go toward the water everyday would go get the animals they had caught."
    },
    "58": {
        "startTime": 424.489,
        "endTime": 433.861,
        "transcript": "Aren uksuuluku up'nerkilriit imkut egkuiruqaqnaurtut natermun-llu ciptaqluteng.",
        "translation": "Oh my, in the winter, the ones who were at spring camp would fill the walls of their houses, and excess would go on the floor."
    },
    "59": {
        "startTime": 433.883,
        "endTime": 446.554,
        "transcript": "Unguvalrianek egkurpallraat qau͡gkut, up'nerkissuutet enet egkuit unguvalrianek muirluteng, natermun ciptaqluteng.",
        "translation": "The huge walls in there, the walls of their spring camp houses would be filled with animals, and the excess would go on the floor."
    },
    "60": {
        "startTime": 447.62,
        "endTime": 450.648,
        "transcript": "Arenqiapakar.",
        "translation": "Oh my goodness."
    },
    "61": {
        "startTime": 450.667,
        "endTime": 454.439,
        "transcript": "Tuaten tua-i angullrenka au͡gkut ayuqellruut.",
        "translation": "That's what the people I was born in time to see back then were like."
    },
    "62": {
        "startTime": 454.446,
        "endTime": 457.26,
        "transcript": "Kitak' uitaqaqaa. Kenriutelliniuq-am una.",
        "translation": "Hold on, please. This ran out of battery."
    },
    "63": {
        "startTime": 457.281,
        "endTime": 463.953,
        "transcript": "...ukut tutga'rma irniarit cali, iluperanka.",
        "translation": "...my grandchildren's children, my great-grandchildren."
    },
    "64": {
        "startTime": 464.154,
        "endTime": 479.526,
        "transcript": "Pangall'am yuin alqaat, Nura'ar-wa, pi-wa, Qussauyaq-wa, Arnaaquq-wa, Tikaaq-wa",
        "translation": "The eldest sister of Pangall'aq's children, Nura'ar, you know, Qussauyaq, Arnaaquq, Tikaaq"
    },
    "65": {
        "startTime": 479.539,
        "endTime": 483.411,
        "transcript": "Ugna-w' kinguqlikacagiit Nanugaq.",
        "translation": "Their youngest sibling downriver, Nanugaq."
    },
    "66": {
        "startTime": 484.93,
        "endTime": 486.715,
        "transcript": "Ii-i.",
        "translation": "I see."
    },
    "67": {
        "startTime": 489.679,
        "endTime": 501.236,
        "transcript": "Uyangqulriim-wa call' irniari talliman, arvinerkaatnek ua-i aqsangluni.",
        "translation": "And Uyangqalria with her five children, pregnant with their sixth downriver."
    },
    "68": {
        "startTime": 502.147,
        "endTime": 506.447,
        "transcript": "Miisaam-wa call' irniari pingayun.",
        "translation": "And Miisaq's three children."
    },
    "69": {
        "startTime": 506.972,
        "endTime": 517.315,
        "transcript": "Ciulluum-wa call' irniara atauciq, kinguqlirkai irnicuaruur[luteng], nuringarmeng an'urluteng.",
        "translation": "And Ciulluk's one child, what would be their younger siblings being miscarried, coming out undeveloped."
    },
    "70": {
        "startTime": 518.067,
        "endTime": 527.838,
        "transcript": "Tallimaurcaaqluteng taukut nuringarmeng anellret, kinguqlirkai uum Ciulluum yuan.",
        "translation": "There are now five who've come out undeveloped, the ones who'd Ciulluk's child's younger siblings."
    },
    "71": {
        "startTime": 528.817,
        "endTime": 540.846,
        "transcript": "Tua-i ingkut-wa cali Kuigilngurmi, Akat'am irniari cali ingkut iluperanka.",
        "translation": "And over in Kwigillingok, Akat'aq's children are my great-grandchildren."
    },
    "72": {
        "startTime": 541.168,
        "endTime": 545.525,
        "transcript": "Atam alqaat maantuq.",
        "translation": "Their oldest sister is here, you see."
    },
    "73": {
        "startTime": 548.406,
        "endTime": 558.891,
        "transcript": "Tungii-wa tayim' cali Cevv'arnermi cali ukurrisngaluni.",
        "translation": "The next younger one has also married as a daughter-in-law in Chefornak."
    },
    "74": {
        "startTime": 559.283,
        "endTime": 562.983,
        "transcript": "Tau͡gaam tailartuq angayuqaagminun.",
        "translation": "But she comes to her parents."
    },
    "75": {
        "startTime": 565.91,
        "endTime": 567.867,
        "transcript": "Ingna-wa...",
        "translation": "The one over there..."
    },
    "76": {
        "startTime": 567.871,
        "endTime": 575.271,
        "transcript": "Imumi alaitelallruut ak'a avani nallevni.",
        "translation": "They were visible long ago during your time."
    },
    "77": {
        "startTime": 575.278,
        "endTime": 578.192,
        "transcript": "Nallemni amllellruut angalkut.",
        "translation": "There were a lot of shamans in my time."
    },
    "78": {
        "startTime": 578.212,
        "endTime": 582.198,
        "transcript": "Kitak' tamakunek wani qanemcitqerkut.",
        "translation": "Please tell us stories about them."
    },
    "79": {
        "startTime": 582.201,
        "endTime": 588.201,
        "transcript": "Waten niitelartukut maa-i wani: assilriit-gguq angalkuut, assiitellriit-llu angalkuut.",
        "translation": "We hear this now: good shamans, and bad shamans."
    },
    "80": {
        "startTime": 588.216,
        "endTime": 594.259,
        "transcript": "Wall'u qaillun. Piciatun pilliunga wiinga. Elpet nallunritaten. Kitak' qanemciqaa tamakunek.",
        "translation": "Or however. I might be speaking nonsense. You know them. Please tell stories about them."
    },
    "81": {
        "startTime": 594.283,
        "endTime": 604.454,
        "transcript": "Ilait maaten im' angalkut murilkenganka tamakut ilait makut yuut qinuciakaqluki.",
        "translation": "Some of them, I noticed that some people on the verge of death would hallucinate seeing those shamans that I observed."
    },
    "82": {
        "startTime": 604.459,
        "endTime": 611.959,
        "transcript": "Tuquqatalriit-ll' ilait qinuciaraaqluteng angalkumek taumek qinuciaracirluteng.",
        "translation": "And some of the people on the verge of death would hallucinate seeing that shaman."
    },
    "83": {
        "startTime": 612.597,
        "endTime": 620.554,
        "transcript": "Tuquqatalriit ilait tuatnaarluteng, taumun tuaten piniluteng.",
        "translation": "Some on the verge of death would do that, saying that he was going after them."
    },
    "84": {
        "startTime": 620.576,
        "endTime": 623.39,
        "transcript": "Qinuciaraaqluteng.",
        "translation": "They hallucinated on the verge of death."
    },
    "85": {
        "startTime": 623.403,
        "endTime": 633.789,
        "transcript": "Ilait tau͡gken makut angalkuuniyaaqengraiceteng watqapik camek qanernaaraunateng angalkuugaqluteng.",
        "translation": "Even though some, however, were said to be shamans, they would be shamans without every having any word said about them."
    },
    "86": {
        "startTime": 633.803,
        "endTime": 640.003,
        "transcript": "Makutun yuunginarrartun ayuqaqluteng qaill' qanernaunateng.",
        "translation": "They would be like ordinary people, with no word said about them."
    },
    "87": {
        "startTime": 640.177,
        "endTime": 644.877,
        "transcript": "Tua-i tau͡gaam tamakunek avullugutengqelallruut.",
        "translation": "However, there were bad ones among them."
    },
    "88": {
        "startTime": 645.173,
        "endTime": 652.43,
        "transcript": "Tangerrluku ilunga'urluan wiinga-llu angalkurtellrulrianga tang.",
        "translation": "Looking at his female cross-cousin, I also caught a shaman, you see."
    },
    "89": {
        "startTime": 653.525,
        "endTime": 657.697,
        "transcript": "Angalkurtellrulrianga qavamkun.",
        "translation": "I caught a shaman in my dream."
    },
    "90": {
        "startTime": 658.42,
        "endTime": 669.92,
        "transcript": "Tua-i maaten tang im' ellangua, qanemcitnaamken, yuilqumi ellangua waten kiirrarma aqumgalrianga nunam qaingani.",
        "translation": "One time, I found myself, let me tell you the story, I found myself in the wilderness, sitting all by myself on the ground."
    },
    "91": {
        "startTime": 670.301,
        "endTime": 677.701,
        "transcript": "Maaten tang caqalriamek niicama ukatmun takuyartua, amik una.",
        "translation": "When I heard something, I turned my head this way and saw a door here."
    },
    "92": {
        "startTime": 677.985,
        "endTime": 687.099,
        "transcript": "Talliq-wa tang man' tallirpilirneq nuna man' tua-i waten agturturluku agiirtellria.",
        "translation": "There was a right arm, you see, touching the ground as it approached."
    },
    "93": {
        "startTime": 687.105,
        "endTime": 693.391,
        "transcript": "Umyuarteqa'artua, \"Aling aren assilriarunripagta tanem man'a.\"",
        "translation": "I thought, \"Oh my goodness, this is not a good things.\""
    },
    "94": {
        "startTime": 694.185,
        "endTime": 704.185,
        "transcript": "Ayumian tekipailganga yaaqsiggaan piicaglua qavamni camani.",
        "translation": "Then before it reached me since it was a little far, I prayed in my sleep down there."
    },
    "95": {
        "startTime": 704.197,
        "endTime": 716.012,
        "transcript": "Atanermun ikayuusqellua, man'a-llu agiirtellria tekiteqatarteka wiinga inglulurutkaanek eneqanaitnilua, nallunritnilua.",
        "translation": "I asked the Lord to help me, and that I knew that I couldn't think of anything to combat this thing approaching that was going to reach me."
    },
    "96": {
        "startTime": 716.016,
        "endTime": 723.844,
        "transcript": "Ayuqiikun ingluliurutkaitnilua, piniliisqellua tau͡gaam.",
        "translation": "I said I had nothing to combat with the same power, but asked to give me strength."
    },
    "97": {
        "startTime": 723.87,
        "endTime": 729.685,
        "transcript": "Pinimek cikiisqellua mat'um tungiinun.",
        "translation": "I asked to be given strength for this situation."
    },
    "98": {
        "startTime": 738.31,
        "endTime": 741.481,
        "transcript": "Tekitellerkamnek qungvangama",
        "translation": "Because I was nervous as it was going to reach me"
    },
    "99": {
        "startTime": 745.4,
        "endTime": 756.9,
        "transcript": "Taqngama uitua waten cetungqallemni irugma akuliigni uluaqa un' ulurpall'er.",
        "translation": "When I was finihsed, I opened my eyes as I was sitting with my legs stretched out to find my huge woman's knife between my legs."
    },
    "100": {
        "startTime": 757.747,
        "endTime": 763.462,
        "transcript": "Qaill' taun' tailarta? Amta-ll' wii yuilqumllua.",
        "translation": "How did that come? Yet I was in the wilderness."
    },
    "101": {
        "startTime": 765.365,
        "endTime": 767.665,
        "transcript": "Teguqerluku.",
        "translation": "I took it."
    },
    "102": {
        "startTime": 767.814,
        "endTime": 773.814,
        "transcript": "Teguqaamku tangrraqa maa-i tua-i tekiteqatallinikiinga.",
        "translation": "When I took it, I saw that it was going to reach me here."
    },
    "103": {
        "startTime": 774.139,
        "endTime": 777.839,
        "transcript": "Atam tua-i caunqegcaqka.",
        "translation": "You see, I turned to face it straight on."
    },
    "104": {
        "startTime": 778.163,
        "endTime": 785.992,
        "transcript": "Tua-i caungamku maa-i tua-i tekiteqataanga waten wavet ciisqumigglua.",
        "translation": "When I faced it as it was going to reach me, I knelt here like this."
    },
    "105": {
        "startTime": 786.169,
        "endTime": 791.927,
        "transcript": "Uluaq waten epuakun tegukeka inglugtun.",
        "translation": "I took the knife with its handle like a [?weapon]."
    },
    "106": {
        "startTime": 792.514,
        "endTime": 800.728,
        "transcript": "Tuani piicaggaarlua uitellruunga ayuqucimtun ayuqevkenii tua-i pinirnganii-llu.",
        "translation": "After I prayed then, I opened my eyes and didn't feel like myself, and I felt strong."
    },
    "107": {
        "startTime": 804.022,
        "endTime": 811.936,
        "transcript": "Tua-lli-wa tua-i maavet unatet elliata waten tallirpilirneret",
        "translation": "And so, when this right hand reached here"
    },
    "108": {
        "startTime": 812.208,
        "endTime": 817.679,
        "transcript": "Wavet uluaq tua-i waten piqerluku ellikeka.",
        "translation": "I did this with the knife and set it down."
    },
    "109": {
        "startTime": 817.825,
        "endTime": 826.654,
        "transcript": "Tua-i-llu-wa tua-i qiaryigtellria. Qelempaglua-ll' wii tua-i qiaryigtellria.",
        "translation": "Then it started crunching. I shut my eyes fast as it crunched."
    },
    "110": {
        "startTime": 826.663,
        "endTime": 831.92,
        "transcript": "Atam qiaryigquraqerluni nunamun kapuartell'.",
        "translation": "As it was crunching, you see, [the knife] stuck into the ground."
    },
    "111": {
        "startTime": 832.426,
        "endTime": 841.44,
        "transcript": "Call' im' qalriuciyaarluni tuar caviyaaq-llu qalrialria. Tayima tua-i qungagarrluni.",
        "translation": "Then something screeched, and it seemed like metal screeching. It withdrew into silence."
    },
    "112": {
        "startTime": 841.931,
        "endTime": 845.745,
        "transcript": "Aren takuya'rqa talliq im' tayima.",
        "translation": "Oh my, I looked back and the arm was gone."
    },
    "113": {
        "startTime": 845.931,
        "endTime": 854.46,
        "transcript": "Aren umyuarteqa'artua, una-w' uluaq nunamun kapusngalria egkuaminun puukaumaluni.",
        "translation": "Oh my, I thought to myself, while this knife stuck into the ground all the way to its handle."
    },
    "114": {
        "startTime": 856.146,
        "endTime": 862.716,
        "transcript": "Aren waniwa-q' [?cull' mercaaqautmun], tau͡gaam kilirngacaaqaqa.",
        "translation": "Oh my, it seemed to [?], but I think I wounded it."
    },
    "115": {
        "startTime": 863.306,
        "endTime": 873.741,
        "transcript": "Maaten tang im' tua makcama man'a avateka kiartaqa, aren unatet makut maani avatemni petgalriit.",
        "translation": "When I got up and looked around my, oh my, I saw these hands springing up around me."
    },
    "116": {
        "startTime": 873.741,
        "endTime": 878.111,
        "transcript": "Uitavkenateng petgalriit qeckaraqluteng.",
        "translation": "The ones that sprang up didn't stay still, but would jump."
    },
    "117": {
        "startTime": 878.251,
        "endTime": 884.281,
        "transcript": "Malirqaaluki tua-i cakiteraqluki.",
        "translation": "I chased them and would chop them."
    },
    "118": {
        "startTime": 884.431,
        "endTime": 889.381,
        "transcript": "Kiituan uitangut. Uitangata qupurrluki.",
        "translation": "Eventually, they stayed still. When they stayed, I chopped them up."
    },
    "119": {
        "startTime": 889.671,
        "endTime": 898.431,
        "transcript": "Piciatun egqaqluki makut yuarat, piciatun egtaqluki quyungqavkarpek'naki.",
        "translation": "I threw these fingers in random directions, threw them in random directions so they wouldn't be gathered."
    },
    "120": {
        "startTime": 898.776,
        "endTime": 908.906,
        "transcript": "Tua-i nutaan caarkaicukaama nangerrlua uluaqa taun' qelkarrluku.",
        "translation": "When I had nothing left to do, I stood up and kept that knife with me."
    },
    "121": {
        "startTime": 909.356,
        "endTime": 915.786,
        "transcript": "Uterqurlua tua-i yaani Kuigilngurmun. Uterqurlua.",
        "translation": "I made my way home over to Kwigillingok. I made my way home."
    },
    "122": {
        "startTime": 918.046,
        "endTime": 929.176,
        "transcript": "Qavangurtulangellruunga tuaten tua-i tamakunek ayuqenrilngurnek uumun imumun Cegg'amun.",
        "translation": "I started to dream about those kinds of things in various ways because of Cegg'aq."
    },
    "123": {
        "startTime": 929.676,
        "endTime": 931.746,
        "transcript": "Cegg'aq una.",
        "translation": "Cegg'aq here."
    },
    "124": {
        "startTime": 932.386,
        "endTime": 937.136,
        "transcript": "Cegg'am waten piyaaqellruanga:",
        "translation": "Cegg'aq said this to me:"
    },
    "125": {
        "startTime": 937.426,
        "endTime": 941.346,
        "transcript": "\"Alingnaqvaa-ll' usuuq tang,\" taangiqluni",
        "translation": "\"Oh my goodness, you,\" he was drunk"
    },
    "126": {
        "startTime": 941.491,
        "endTime": 945.221,
        "transcript": "\"Usuuq tang yuungcariqernaamken.\"",
        "translation": "\"Hey you, let me heal you.\""
    },
    "127": {
        "startTime": 945.891,
        "endTime": 954.111,
        "transcript": "Ingna-gguq, ingna-gguq tang yaa-i Ayagina'ar yuungcarallra man'a tekiskii.",
        "translation": "He said that he had healed Ayagina'ar over there, the one who made it this far."
    },
    "128": {
        "startTime": 954.456,
        "endTime": 957.436,
        "transcript": "\"Yuungcariqernaamken.",
        "translation": "\"Let me heal you."
    },
    "129": {
        "startTime": 957.941,
        "endTime": 968.651,
        "transcript": "\"Eru'urqavet, ervuqa'arqavet ervuqalaryartuten yuungcarikumken unaken taryumek eruutan avuqerluku.\"",
        "translation": "\"When you wash yourself, when you bathe, if I heal you, you would bathe adding in your bathwater with saltwater from down there.\""
    },
    "130": {
        "startTime": 968.901,
        "endTime": 976.821,
        "transcript": "Tua-i-gguq elliin-llu ca im' yuungcararkaq ilaaqluku yuungcaraqeciqaa",
        "translation": "He said that he would add on who should be healed, then heal them"
    },
    "131": {
        "startTime": 976.956,
        "endTime": 979.816,
        "transcript": "Tautun Ayagina'artun.",
        "translation": "Like Ayagina'ar there."
    },
    "132": {
        "startTime": 980.681,
        "endTime": 985.901,
        "transcript": "Aren wii tua-i tamana umyuama pinrilaku",
        "translation": "Oh my, since my mind didn't want that"
    },
    "133": {
        "startTime": 986.066,
        "endTime": 990.686,
        "transcript": "Piaqa wavet canritniluku waten erurang'e'rma.",
        "translation": "I told him that it would be fine if I continued to wash this way."
    },
    "134": {
        "startTime": 991.051,
        "endTime": 997.461,
        "transcript": "Canritniluku waten erurang'e'rma. Tuaten wii piyuumiitnilua.",
        "translation": "I told him it would be fine if I continued to wash like this. I said I didn't want to do that."
    },
    "135": {
        "startTime": 997.751,
        "endTime": 1005.061,
        "transcript": "Qavanguqevkalangellruuq tua-i tauna ngelekluku ciuniunritelqa.",
        "translation": "He started making me dream since then, because I didn't accept his offer."
    },
    "136": {
        "startTime": 1005.121,
        "endTime": 1010.661,
        "transcript": "Tua-i tuani tua-i tayima tua qavanguqenrirluku.",
        "translation": "Since then, I stopped dreaming about him."
    },
    "137": {
        "startTime": 1010.666,
        "endTime": 1015.376,
        "transcript": "Tuaten tau͡gaam qavangurturaqlua canek tamakunek.",
        "translation": "But I would dream about those strange things like that."
    },
    "138": {
        "startTime": 1015.776,
        "endTime": 1019.516,
        "transcript": "Uterrlua tua-i tekillua.",
        "translation": "I made my way home and arrived."
    },
    "139": {
        "startTime": 1022.441,
        "endTime": 1029.391,
        "transcript": "Aren maaten tang tuani kiartua taukut unatet kepraarluku",
        "translation": "Oh my, I looked around after I cut those hands up"
    },
    "140": {
        "startTime": 1029.391,
        "endTime": 1033.711,
        "transcript": "Tuani tua-i up'nerkaryarturtuq",
        "translation": "At that time, spring was nigh"
    },
    "141": {
        "startTime": 1033.836,
        "endTime": 1040.026,
        "transcript": "Alussistuallruluteng-llu. Waniw' yaaqsigpek'nani Alussistuallrat.",
        "translation": "And they had celebrated Christmas. It was long since they'd celebrated Christmas."
    },
    "142": {
        "startTime": 1041.246,
        "endTime": 1045.381,
        "transcript": "Nuna man' qainga urullinilria tua-i.",
        "translation": "The ground surface had melted."
    },
    "143": {
        "startTime": 1045.381,
        "endTime": 1052.391,
        "transcript": "Nanvat-llu makut urugaqluki, tau͡gaam cikuit urumaksaunateng.",
        "translation": "And these lakes were melting, but their ice hadn't melted yet."
    },
    "144": {
        "startTime": 1052.931,
        "endTime": 1058.931,
        "transcript": "Makut-llu kuiget emiqaqtaangelliniluteng akulait.",
        "translation": "And the area between rivers had started gtetting water."
    },
    "145": {
        "startTime": 1059.096,
        "endTime": 1064.626,
        "transcript": "Tua-i kiarrlua nunam qainga tuaten ayuqluku.",
        "translation": "I looked around with the land like that."
    },
    "146": {
        "startTime": 1064.756,
        "endTime": 1075.486,
        "transcript": "Uterrlua tua-i tekicama tua-i enemteńun itrama, qavauciqa nallunriqerrluku tua-i tupagyarturlua uiga'rrlua.",
        "translation": "When I went home and arrived, when I went into our house, I realized that I was sleeping, tried to awake myself and opened my eyes."
    },
    "147": {
        "startTime": 1075.846,
        "endTime": 1082.566,
        "transcript": "Tua uigarcama tua-i at'urlua tayim' uum qaill' piciiranga qanrulluku.",
        "translation": "When I woke up and their poor father asked what happened to me, I told him."
    },
    "148": {
        "startTime": 1085.211,
        "endTime": 1090.721,
        "transcript": "Qavangurturnilua au͡g'umek tua-i tuaten ayuqelriamek.",
        "translation": "I told him that I had that kind of dream."
    },
    "149": {
        "startTime": 1092.891,
        "endTime": 1103.171,
        "transcript": "Waniwa tua-i qavanguqa au͡gna piciukan kelluqu'rciqnilua up'nerkarpak qaill' ellam ayuqucianek.",
        "translation": "If my dream was true, I said that I would watch all spring for what nature out there was like."
    },
    "150": {
        "startTime": 1103.366,
        "endTime": 1108.566,
        "transcript": "Tua-i waten-am qanruskilaku engelii tekitevkenaku.",
        "translation": "I told him this without reaching the point."
    },
    "151": {
        "startTime": 1108.891,
        "endTime": 1112.481,
        "transcript": "Tua-i-ll' kelluqurlua tua-i.",
        "translation": "Then I kept watch."
    },
    "152": {
        "startTime": 1112.601,
        "endTime": 1121.251,
        "transcript": "Imumi-llu avani, pelatekiulallrat-qa nallullruan, Kuigilnguum paingan pelatekalilallra?",
        "translation": "And a long time ago, did you know that they would set up a lot of tents at the mouth of the Kuigilnguq River?"
    },
    "153": {
        "startTime": 1121.291,
        "endTime": 1127.681,
        "transcript": "Tengmiarsuunkut kiingan anguqallruanka. Nangenruluteng pingatellruut ellait.",
        "translation": "I was only born in time to see Tengmiarsuk and family. I think they were the last ones."
    },
    "154": {
        "startTime": 1127.931,
        "endTime": 1136.281,
        "transcript": "Una wani ukalirnerna Kuigilnguum pelatekat un'gani amllepiatullruut uaqlirni.",
        "translation": "On this side of Kuigilnguq, there used to be a multitude of tents far downriver."
    },
    "155": {
        "startTime": 1136.361,
        "endTime": 1141.351,
        "transcript": "Waniw' cali kiaqliitni cali tua-i pelatekarugaat.",
        "translation": "There were also a lot of tents here upriver from them."
    },
    "156": {
        "startTime": 1141.451,
        "endTime": 1147.851,
        "transcript": "Agna-ll' call' akilirneq ikna pelatelartangqerraqluni pelatekarugarnek.",
        "translation": "And across from them, there would be a lot of tents."
    },
    "157": {
        "startTime": 1149.996,
        "endTime": 1154.316,
        "transcript": "Anelraqutullratni painganun Kuigilnguum.",
        "translation": "When they used to go downriver en masse to the mouth of Kuigilnguq."
    },
    "158": {
        "startTime": 1154.841,
        "endTime": 1157.481,
        "transcript": "Arenqiapakar.",
        "translation": "Oh my goodness."
    },
    "159": {
        "startTime": 1157.906,
        "endTime": 1160.286,
        "transcript": "Tua-i tuaten tua-i.",
        "translation": "That's what they did."
    },
    "160": {
        "startTime": 1161.001,
        "endTime": 1169.511,
        "transcript": "Anelrarluta tua-i ikani akilirnermi uitaluta wangkuta. Yugyagluteng.",
        "translation": "We went downriver and stayed across on the other side. There were a lot of people."
    },
    "161": {
        "startTime": 1169.511,
        "endTime": 1177.831,
        "transcript": "Iluraruka-ll' [?]m Arnaan-llu elaqliqlunuk, canritellrani tamaani cayugnaitellrani.",
        "translation": "And my cousin, [?]'s mother and I were neighbors, back when she was alive and well."
    },
    "162": {
        "startTime": 1178.916,
        "endTime": 1185.996,
        "transcript": "Atam tua-i uitaqainanemteńi unaken tua-i unguvalriarqaqengluteng.",
        "translation": "As we stayed, you see, they started catching a lot of animals from down [in the ocean]."
    },
    "163": {
        "startTime": 1186.281,
        "endTime": 1195.551,
        "transcript": "It'gayagikenka-am ukut qaqingnaqluki tua-i it'gayagiarkanka au͡gkut nayiit amiit.",
        "translation": "I made \"little feet [?]\" trying to finish them all, the ringed seal skins I had to make into \"little feet.\""
    },
    "164": {
        "startTime": 1195.901,
        "endTime": 1201.191,
        "transcript": "Atam piinanemteńi yuk cakem' amik ikireskii.",
        "translation": "As we were doing that, you see, a person out there opened the door."
    },
    "165": {
        "startTime": 1201.271,
        "endTime": 1210.621,
        "transcript": "Pelatekangqertukut imumek tungupagmkek, tanqiucirluku qatellriamek qukaakun.",
        "translation": "We had a black tent, with a white part in the middle to let in light."
    },
    "166": {
        "startTime": 1211.211,
        "endTime": 1214.421,
        "transcript": "Tua-i tuaten ayuqukut.",
        "translation": "That's what we were like."
    },
    "167": {
        "startTime": 1215.631,
        "endTime": 1226.311,
        "transcript": "Qanertuq iterluni pama-i yuk pam' tununmni Qayum atii canritlermini.",
        "translation": "The person said as he came in behind me, Qayuq's father when he was alive."
    },
    "168": {
        "startTime": 1226.866,
        "endTime": 1231.526,
        "transcript": "Tua-ll' atrat una pia, Acill'aq pia",
        "translation": "Then he said to their namesake, he said to Acill'aq"
    },
    "169": {
        "startTime": 1231.851,
        "endTime": 1235.171,
        "transcript": "\"Iluracung' tang ikegkut ullakarki.\"",
        "translation": "\"Cousin, you should go to them across there.\""
    },
    "170": {
        "startTime": 1235.326,
        "endTime": 1241.126,
        "transcript": "Tua-i-gguq ata tang ellii iluminek pivakaami ullanrilkai.",
        "translation": "He said that he wasn't going to them because he was having stomach problems."
    },
    "171": {
        "startTime": 1242.591,
        "endTime": 1246.621,
        "transcript": "Tua-ll' piunga wii cat imkut.",
        "translation": "Then I noticed those things."
    },
    "172": {
        "startTime": 1246.861,
        "endTime": 1252.301,
        "transcript": "Aren qanertuq, tauna-gguq Cegg'aq yuunrirtuq.",
        "translation": "Oh my, he said that Cegg'aq passed away."
    },
    "173": {
        "startTime": 1252.936,
        "endTime": 1260.116,
        "transcript": "Aren qaillun tua-i pivkenani, qaillun pivkenani tamaani.",
        "translation": "Oh my, nothing was wrong with him, nothing was wrong with him at that time."
    },
    "174": {
        "startTime": 1260.641,
        "endTime": 1264.381,
        "transcript": "Aren piunga, \"Qaillun un' pia?“",
        "translation": "Oh my, I said, \"What happened to him?\""
    },
    "175": {
        "startTime": 1264.506,
        "endTime": 1270.676,
        "transcript": "Tua-i-gguq-wam antelallni antellerminiu tua-i yuunrilria",
        "translation": "They said that when we coughed up what he coughed up, he passed away"
    },
    "176": {
        "startTime": 1272.866,
        "endTime": 1275.366,
        "transcript": "Qecingarcami.",
        "translation": "Because he'd started coughing up [blood]."
    },
    "177": {
        "startTime": 1276.711,
        "endTime": 1278.111,
        "transcript": "Arenqia.",
        "translation": "Oh my goodness."
    },
    "178": {
        "startTime": 1278.116,
        "endTime": 1282.291,
        "transcript": "Tua-i-ll' tayima tua-i qerarlutek maliklutek.",
        "translation": "Then they crossed [the river] together."
    },
    "179": {
        "startTime": 1282.291,
        "endTime": 1291.141,
        "transcript": "Qeraagnek caliyuumiircama calianka peggluki anngama nunam qainga kiartaqa",
        "translation": "When they crossed and I didn't want to work anymore, I dropped what I was working, went out, and look around the land"
    },
    "180": {
        "startTime": 1291.371,
        "endTime": 1295.641,
        "transcript": "Imna qavangulqa uksuq umyuaqluku.",
        "translation": "Remembering what I had dreamt the last winter."
    },
    "181": {
        "startTime": 1296.321,
        "endTime": 1303.491,
        "transcript": "Tua-i tekitqapiarluku tua-i tauna yuk arulaillinilria.",
        "translation": "That person passed away right at that exact point."
    },
    "182": {
        "startTime": 1304.031,
        "endTime": 1312.801,
        "transcript": "Un'a-w' kuik cali emiqaqtaarluni, makuk ceńak emiqaqtaarlutek pilriik.",
        "translation": "And the river down there was getting watery, both sides of the riverbank were getting watery."
    },
    "183": {
        "startTime": 1313.071,
        "endTime": 1317.661,
        "transcript": "Aren tua-i qavangulqa im' tekitkacagarluku.",
        "translation": "Oh my, it was exactly what I had dreamt."
    },
    "184": {
        "startTime": 1318.471,
        "endTime": 1323.321,
        "transcript": "Aren. Tuani tua-i alingepiallruunga.",
        "translation": "Oh my. I was so scared at that time."
    },
    "185": {
        "startTime": 1323.871,
        "endTime": 1326.442,
        "transcript": "Alingellruunga-wa.",
        "translation": "I was scared."
    }
};